import CrudTable from '../../crud/CrudTable'
import { timetableService as service } from '../../../services'

const initFilter = {
    car: null,
    company: null,
    cartype: null,
}

export default function Timetable() {
    const paintCell = {
        day: (value, object) => {
            if (object['day'] && object['day'] > 0) {
                if (object['day'] === 1) {
                    return <span>Domingo</span>
                } else if (object['day'] === 2) {
                    return <span>Lunes</span>
                } else if (object['day'] === 3) {
                    return <span>Martes</span>
                } else if (object['day'] === 4) {
                    return <span>Miercoles</span>
                } else if (object['day'] === 5) {
                    return <span>Jueves</span>
                } else if (object['day'] === 6) {
                    return <span>Viernes</span>
                } else if (object['day'] === 7) {
                    return <span>Sabado</span>
                }
            } else if (object['allDays']) {
                return <span>Todos los días</span>
            } else if (object['weekend']) {
                return <span>Fin de semana</span>
            } else if (object['workingDays']) {
                return <span>De lunes a viernes</span>
            } else {
                return <span> --</span>
            }
        },
    }
    return (
        <CrudTable
            service={service}
            urledit={'/timetable/edit/'}
            urlnew={'/timetable/new/'}
            hiddenFilter={true}
            filter={initFilter}
            paintCell={paintCell}
            deleteaction={true}
            notexport={true}
            i18n={'timetable'}
            fieldstable={[
                'day',
                'hourStartMorning',
                'endStarMorning',
                'hourStartAfternoon',
                'endStarAfternoon',
            ]}
            labels={{ username: 'Usuario' }}
        />
    )
}
